import React from 'react';
import { MetadataService } from '@wix/cashier-core/dist/src/services/Metadata';
import { Theme } from '../../../../types/Theme';
import { DropdownField } from '../DropdownField';
import { DH } from '../../../../utils/DataHook';
import { BaseFieldProps } from '../types';
import { patchMetadataServiceBaseURL } from '../utils';

export interface CountryDropdownProps extends BaseFieldProps {
  host?: string;
}

export const CountryDropdown: React.FunctionComponent<CountryDropdownProps> = (
  props
) => {
  const fetchCountryItems = () =>
    new MetadataService({
      baseURL: patchMetadataServiceBaseURL(props.host),
      // baseURL: props.host,
    }).fetchCountries(props.locale);

  return (
    <div data-hook={DH.PaymentDetails.CountryDropdown}>
      <DropdownField
        fetchItems={fetchCountryItems}
        // currently widget re-renders on every change in country field
        withInputFallback={false}
        {...props}
        theme={props.theme || Theme.default}
      />
    </div>
  );
};
CountryDropdown.displayName = 'CountryDropdown';
